/**
 * Schreibaufträge der Grundschrift (`darstellung.schriftPt`) je SiGe-Projekt —
 * nacheinander und über Vorschau-Fenster hinweg (Codex-Review 04.10.2026).
 *
 *  - Zwei schnelle Reglerstopps dürfen sich auf dem Netz nicht überholen,
 *    sonst bliebe in der Datenbank der ältere Wert.
 *  - Ein Auftrag, für den schon ein neuerer ansteht, schreibt nicht mehr —
 *    auch dann nicht, wenn der neuere aus einer neu geöffneten Vorschau
 *    kommt. Eine Kette je Fenster reichte dafür nicht: schließt man die
 *    Vorschau mit eingereihtem Auftrag und stellt in der nächsten einen
 *    anderen Wert ein, überschrieb der alte Auftrag den neuen.
 *  - Scheitert ein Auftrag, meldet er das nur, wenn seither nichts Neueres
 *    eingestellt wurde — sonst drehte sein Rücksprung eine neuere Einstellung
 *    zurück.
 */
interface Schlange {
    kette: Promise<void>;
    stand: number;
}

const schlangen = new Map<string, Schlange>();

export interface SchriftAuftrag {
    schreibe: () => Promise<void> | void;
    /** Nur, wenn dieser Auftrag nach dem Schreiben noch der jüngste ist. */
    beiErfolg?: () => void;
    /** Nur, wenn dieser Auftrag beim Scheitern noch der jüngste ist. */
    beiFehler?: (e: unknown) => void;
}

/** Reiht einen Auftrag ein; das Promise erfüllt sich, wenn die Kette bis hierher abgearbeitet ist. */
export const reiheSchriftAuftrag = (projektKey: string, auftrag: SchriftAuftrag): Promise<void> => {
    let schlange = schlangen.get(projektKey);
    if (!schlange) {
        schlange = { kette: Promise.resolve(), stand: 0 };
        schlangen.set(projektKey, schlange);
    }
    const s = schlange;
    const meiner = ++s.stand;
    s.kette = s.kette.then(async () => {
        if (meiner !== s.stand) return; // überholt: der neuere Auftrag schreibt
        try {
            await auftrag.schreibe();
            if (meiner === s.stand) auftrag.beiErfolg?.();
        } catch (e) {
            if (meiner === s.stand) auftrag.beiFehler?.(e);
        }
    });
    return s.kette;
};
